import { useFormikContext } from 'formik';
import React, { FC } from 'react';
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { MobileAccount } from '../../../models/Account';
import { MultiSelectOption } from '../../../models/MultiSelectOption';

interface SummaryFormProps {
    onBack: (event: any) => void;
    account: MobileAccount | undefined;
    selectedUsedWith: MultiSelectOption;
    task: string;
    subTask: string;
}

const SummaryForm: FC<SummaryFormProps> = ({ account, onBack, selectedUsedWith, task, subTask }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return <div className="pt-3 pr-3 h-full relative">
        <h2 className="text-lg font-bold">{translate.byKey(TranslationKeys.taskDetails)}:</h2>
        <div className="flex flex-row">
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.task)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.procedure)}:</span>
            </div>
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-black pl-2">{task}</span>
                <span className="pt-1 text-sm text-black pl-2">{subTask}</span>
            </div>
        </div>

        <h2 className="text-lg font-bold pt-4">{translate.byKey(TranslationKeys.enrolmentDetails)}:</h2>
        <div className="flex flex-row">
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.email)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.account)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.usedWith)}:</span>
            </div>
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-black pl-2">{values.userEmail}</span>
                <span className="pt-1 text-sm text-black pl-2">{account?.name}</span>
                <span className="pt-1 text-sm text-black pl-2">{selectedUsedWith.label}</span>
            </div>
        </div>

        <div className="flex justify-end w-full absolute bottom-0 pr-3 pb-3 ">
            <button
                className={`py-1 px-5 mt-3 mr-2 text-portal-blue-primary-shade2`}
                type="button"
                onClick={(e) => onBack(e)}>
                {translate.byKey(TranslationKeys.back)}
            </button>
            <button
                className={`py-1 px-5 secondary secondary-enabled`}
                type="submit">
                {translate.byKey(TranslationKeys.confirm)}
            </button>
        </div>
    </div>
}

export default SummaryForm;
